import { useEffect } from 'react';
import { useConfigOption } from './useConfigOption';

const isCustomFontProp = (styleRule: CSSStyleRule) => {
  if (styleRule.selectorText !== ':root') return false;
  if (styleRule.style[0] !== '--custom-font-family') return false;
  return true;
};

const filterNonFontProps = (sheet: CSSStyleSheet) => {
  const ruleList = sheet.cssRules;
  for (let i = 0; i < ruleList.length; i++) {
    if (ruleList[i].constructor === CSSFontFaceRule) continue;
    if (ruleList[i].constructor === CSSStyleRule) {
      const styleRule = ruleList[i] as CSSStyleRule;
      if (isCustomFontProp(styleRule)) continue;
    }
    sheet.deleteRule(i);
  }
};

const exists = (url: string) => [...document.styleSheets].some(({ href }) => href === url);

const onload = (element: HTMLLinkElement) => () => {
  if (!element.sheet) return;
  filterNonFontProps(element.sheet);
};

const create = (url: string) => {
  const element = document.createElement('link');
  element.rel = 'stylesheet';
  element.type = 'text/css';
  element.crossOrigin = 'anonymous';
  element.href = url;
  element.onload = onload(element);
  return element;
};

const insert = (url: string) => {
  const element = create(url);
  document.head.appendChild(element);
};

export const useCustomStyleSheet = () => {
  const url = useConfigOption('customStyleSheet', '');

  useEffect(() => {
    if (url === '') return;
    if (exists(url)) return;
    insert(url);
  }, [url]);
};
